// extracted by mini-css-extract-plugin
export default {"funding-page-container":"Funding_page_funding-page-container__IJdRi","full-width":"Funding_page_full-width__lpMtS","warning-modal-header":"Funding_page_warning-modal-header__zscTR"};